export default {
  auth: '/api/v1/identity/login',
  logout: '/api/v1/identity/logout',
  emailVerification: '/api/v1/identity/verify',
  accountActivation: '/api/v1/identity/activate',
  ownUserInfo: '/api/v1/identity/whoami',
  clientDetail: '/api/v1/identity/clients/detail',
  clientCompanyCreateEdit: '/api/v1/identity/clients/detail',
  clientContractCreateEdit: '/api/v1/identity/clients/contract',
  userList: '/api/v1/identity/users/filter',
  userBatchCreate: '/api/v1/identity/users/batch',
  clientList: '/api/v1/identity/clients/filter',
  clientStatus: '/api/v1/identity/clients',

  locationList: '/api/v1/orders/locations/filter',
  locationDetail: '/api/v1/orders/locations',
  provinceList: '/api/v1/orders/provinces/filter',
  cityList: '/api/v1/orders/cities/filter',
  districtList: '/api/v1/orders/districts/filter',
  subDistrictList: '/api/v1/orders/subdistricts/filter',
  urbanVillageList: '/api/v1/orders/urbanvillages/filter',

  categoryList: '/api/v1/orders/categories/filter',
  categoryDetail: '/api/v1/orders/categories',
  subCategories: (categoryId) => `/api/v1/orders/categories/${categoryId}/sub`,

  vehicleList: '/api/v1/orders/transport-types/filter',
  contractRouteAndTransport: '/api/v1/orders/contracts/origins-destinations-vehicles/client',
  contractPriceList: '/api/v1/orders/contracts/price/client',

  shipmentGroup: '/api/v1/orders/shipments/group/filter',
  shipmentGroupDetail: '/api/v1/orders/shipments/group',
  shipmentConfirmation: '/api/v1/orders/shipments/shipper/overwrite',
  orderList: '/api/v1/orders/shipments/filter',
  orderDetail: '/api/v1/orders/shipments',
  orderStatusHistory: (orderId) => `/api/v1/delivery/shipments/${orderId}/status-history`,
  orderSummary: '/api/v1/orders/shipments/summary',
  orderSchedule: '/api/v1/orders/shipments/calendar',
  orderQuantity: '/api/v1/orders/shipments/action/quantity-info',
  orderCalculatedQuantity: '/api/v1/orders/calculate-cost',
  orderDocuments: (orderId, type) => `/api/v1/orders/shipments/${orderId}/document/${type}`,
  orderDocumentCompletion: '/api/v1/orders/shipments/action/document-mark',
  orderDocumentUpdate: '/api/v1/orders/shipments/document/update',
  orderCancel: '/api/v1/orders/shipments/action/cancel',
  orderUpdateStatus: '/api/v1/orders/shipments/assigned/update',
  orderContractUnitOptions: '/api/v1/orders/contracts/unit',
  shipmentGroupList: '/api/v1/orders/shipments/group/filter',
  shipmentListByGroupId: '/api/v1/orders/shipments/filter',
  orderListPageSizes: '/api/v1/orders/parameter/pagination',

  transactionList: '/api/v1/transaction/shipments/filter',
  transaction: '/api/v1/transaction',
  invoiceList: '/api/v1/transaction/invoice/filter',
  invoiceStatus: '/api/v1/transaction/invoice/status',
  invoiceDetail1: '/api/v1/transaction/invoice/detail-1',
  invoiceDetail2: '/api/v1/transaction/invoice/detail-2',
  invoiceCommonData: '/api/v1/transaction/common/data/invoice',
  invoiceEditTransactionList: '/api/v1/transaction/list/proforma',
  invoice: '/api/v1/transaction/invoice',
  emailInvoice: '/api/v1/transaction/invoice/email',
  resubmitToOracle: '/api/v1/transaction/invoice/resubmit/oracle',

  availableVehicleNo: (clientId, fixPriceId) => `/api/v1/orders/contracts/price/client/${clientId}/transporter/${fixPriceId}/vehicles`,
  availableTransporters: (orderId) => `/api/v1/orders/shipments/${orderId}/transporter/available`,
  availableVehicles: (orderId, transporterId) => `/api/v1/orders/shipments/${orderId}/${transporterId}/transport/available`,
  assignTransporter: '/api/v1/orders/shipments/action/assign',
  reassignTransporter: '/api/v1/orders/shipments/action/reassign/transporter',

  uploadImage: '/api/v1/image-upload',
  uploadCsv: '/api/v1/orders/upload/csv',
  uploadedCsvStatus: 'api/v1/orders/upload/filter',
  uploadedCsvDetail: 'api/v1/orders/upload/detail',
  csvTemplateData: '/api/v1/orders/upload/template',

  transportTypeDetail: '/api/v1/orders/transport-types',
  selectionInfo: '/api/v1/orders/selection-info',
  selectionInfoFilter: '/api/v1/orders/selection-info/filter',

  shipmentAccidentList: '/api/v1/orders/shipments/accident/filter',
  newAccidentCount: '/api/v1/orders/shipments/accident/counter',
  processProblem: '/api/v1/orders/shipments/accident/proceed',
  resolveProblem: '/api/v1/orders/shipments/accident/resolve',
  shipmentProblemLastLoc: '/api/v1/orders/shipments/accident/location',
  shipmentProblem: '/api/v1/orders/shipments/accident/detail',

  getVehicleType: '/api/v1/orders/report/transport-types',
  getCustomerDetail: '/api/v1/orders/report/customer-detail',
  getListBasp: '/api/v1/orders/report/basp/fli',
  get3PLTransportRating: '/api/v1/orders/report/rating/transport',
  get3PLDriverRating: '/api/v1/orders/report/rating/driver',
  get3PLShipmentRating: '/api/v1/orders/report/rating/shipment',
  get3PLRating: '/api/v1/orders/report/rating/transporter',
  getCategories: '/api/v1/orders/report/category',
  getSubCategories: '/api/v1/orders/report/sub-category',
  getRitase: '/api/v1/orders/report/ritase',
  getInvoiceCustomer: '/api/v1/transaction/report/invoice/customer',
  getAgingReport: '/api/v1/transaction/report/invoice/aging/fli',
  getIncomeReport: '/api/v1/transaction/report/invoice/income/fli',
  getClientReportCsv: '/api/v1/orders/report/client',
  getTaxRecap: '/api/v1/transaction/report/invoice/rekap',
  getTransporterRatingByTransport: '/api/v1/orders/report/rating/bytransportype',
  getTransporterRatingByDriver: '/api/v1/orders/report/rating/bydriver',
  getOrderReport: 'api/v1/orders/report/shipment/fli',
  getDataArmadaReport: 'api/v1/orders/report/transport/fli',

  taxList: '/api/v1/transaction/tax/filter',
  taxListCsv: '/api/v1/transaction/tax/csv',

  damagedAndMissingList: '/api/v1/orders/shipments/damage/filter',
  damagedAndMissingDetail: '/api/v1/orders/shipments/damage/detail',

  userDetail: '/api/v1/identity/users',
  userActivation: '/api/v1/identity/users/active-deactive',
  userResetPassword: '/api/v1/identity/users/reset',

  notification: '/api/v1/identity/notifications',
  notificationList: '/api/v1/identity/notifications/filter',
  notificationUnreadCount: '/api/v1/identity/notifications/counter',

  locationOrigin: '/api/v1/orders/contracts/locations/origin',
  locationDestination: '/api/v1/orders/contracts/locations/destination',

  baspList: '/api/v1/orders/basp/filter',
  baspDetail: '/api/v1/orders/basp',

  parameterListGroup: 'api/v1/orders/parameter/group/filter',
  parameterListMaster: 'api/v1/orders/parameter/filter',
  parameterById: '/api/v1/orders/parameter',
  locationsFromOrders: '/api/v1/orders/shipments/transaction/location/filter',
  vehiclesFromOrders: '/api/v1/orders/shipments/transaction/vehicle/filter',
}
